<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <div class="smartphone-size" :style="getStyles('smartphone')">
                <mimic-amp-img :image="contents.image"></mimic-amp-img>
              </div>
              <div class="tablet-size" :style="getStyles('tablet')">
                <mimic-amp-img :image="contents.image"></mimic-amp-img>
              </div>
              <div class="desktop-size" :style="getStyles('desktop')">
                <mimic-amp-img :image="contents.image"></mimic-amp-img>
              </div>
            </div>
          </section>

        </div>
      </div>

      <el-dialog width="90%" title="画像の選択" :visible.sync="dialogImageSelectVisible">
        <select-image v-model="selectedImage" @change="onUpdateImage"></select-image>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogImageSelectVisible = false">キャンセル</el-button>
          <el-button type="primary" @click="onUpdateImage">選択</el-button>
        </span>
      </el-dialog>

      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item :label="contents.fullWidth ? 'スマホサイズでの画像幅（ウィンドウの幅に対する割合: 1 ~ 100）': 'スマホサイズでの画像幅（コンテンツの幅に対する割合: 1 ~ 100）'">
          <el-input-number v-model="contents.smartphone.size" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-form-item label="スマホサイズでの画像の寄せ">
          <el-radio-group v-model="contents.smartphone.position">
            <el-radio label="left">左寄せ</el-radio>
            <el-radio label="center">中央寄せ</el-radio>
            <el-radio label="right">右寄せ</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="contents.fullWidth ? 'タブレットサイズでの画像幅（ウィンドウの幅に対する割合: 1 ~ 100）' : 'タブレットサイズでの画像幅（コンテンツ幅に対する割合: 1 ~ 100）'">
          <el-input-number v-model="contents.tablet.size" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-form-item label="タブレットサイズでの画像の寄せ">
          <el-radio-group v-model="contents.tablet.position">
            <el-radio label="left">左寄せ</el-radio>
            <el-radio label="center">中央寄せ</el-radio>
            <el-radio label="right">右寄せ</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="contents.fullWidth ? 'デスクトップサイズでの画像幅（ウィンドウの幅に対する割合: 1 ~ 100）' : 'デスクトップサイズでの画像幅（コンテンツ幅に対する割合: 1 ~ 100）'">
          <el-input-number v-model="contents.desktop.size" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-form-item label="デスクトップサイズでの画像の寄せ">
          <el-radio-group v-model="contents.desktop.position">
            <el-radio label="left">左寄せ</el-radio>
            <el-radio label="center">中央寄せ</el-radio>
            <el-radio label="right">右寄せ</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="contents.fullWidth">画像をウィンドウ幅まで広げる</el-checkbox>
        </el-form-item>
        <el-form-item label="リンク先URL">
          <el-input class="width-75" v-model="contents.link.href" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="contents.link.blank">リンク先を新たなタブで開く</el-checkbox>
        </el-form-item>
        <el-button @click="onSelectImage(contents.image)">画像の選択</el-button>
        <div class="image-info flex column justify-between items-center">
          <img class="image-info-img" :src="contents.image.src">
          <p class="image-info-size">画像のサイズ：{{ contents.image.width }}x{{ contents.image.height }}</p>
        </div>
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'
import MimicAmpImg from '@/components/mimic-amp/MimicAmpImg'
import SelectImage from '@/components/app/SelectImage'

export default {
  name: 'slide-with-image',
  components: {
    'mimic-amp-img': MimicAmpImg,
    'select-image': SelectImage
  },
  mixins: [ComponentBase],
  data: function () {
    return {
      labelWidth: '11em',
      selectedImage: {
        id: null,
        src: null,
        width: null,
        height: null
      },
      dialogImageSelectVisible: false
    }
  },
  watch: {
    selectedImage: function (newVal) {
      console.log(newVal)
    }
  },
  methods: {
    getStyles: function (type) {
      const width = `width: ${this.contents[type].size}%;`
      switch (this.contents[type].position) {
        case 'left':
          return width + 'margin-left:0;margin-right:auto;'
        case 'center':
          return width + 'margin-left:auto;margin-right:auto;'
        case 'right':
          return width + 'margin-left:auto;margin-right:0;'
      }
    },
    /**
     * 「画像の選択」ボタンがクリックされたら、contents.imageの各プロパティを
     * this.selectedImageにコピーする
     */
    onSelectImage: function (image) {
      const found = this.media.find(img => img.source_url === image.src)
      if (process.env.NODE_ENV !== 'production') console.log(found)
      image.id = found ? found.id : 0

      this.selectedImage.id = image.id
      this.selectedImage.src = image.src
      this.selectedImage.width = image.width
      this.selectedImage.height = image.height
      this.dialogImageSelectVisible = true
    },
    /**
     * ダイアログで画像を選択したら、選択した画像をidを元にthis.mediaから探し、
     * その画像の情報をthis.contents.imageに格納する
     */
    onUpdateImage: function () {
      const selected = this.media.find(image => image.id === this.selectedImage.id)
      this.contents.image.id = selected.id
      this.contents.image.src = selected.source_url
      this.contents.image.width = selected.media_details.width
      this.contents.image.height = selected.media_details.height
      this.dialogImageSelectVisible = false
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      const imageDirection = contents.image.width > contents.image.height ? 'landscape' : 'portrait'
      const ampImage = `<amp-img class="slide-img amp-img-cover ${imageDirection}" width="${contents.image.width}" height="${contents.image.height}" layout="responsive" src="${contents.image.src}"></amp-img>`

      let anchor = ''
      if (contents.link.href) {
        anchor += `<a class="SlideImage2-a block slide-inner" href="${contents.link.href}" ${contents.link.blank ? 'target=_blank' : ''}>${ampImage}</a>`
      } else {
        anchor += `<div class="slide-inner">${ampImage}</div>`
      }

      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          ${anchor}
        </div>
      </section>`.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)

      layout += `
      .${this.meta.file}-${this._uid} .slide-inner{${this.getStyles('smartphone')}}
      @media (min-width: 768px) {.${this.meta.file}-${this._uid} .slide-inner{${this.getStyles('tablet')}}}
      @media (min-width: 1025px) {.${this.meta.file}-${this._uid} .slide-inner{${this.getStyles('desktop')}}}
      `

      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      return {layout, theme}
    }
  },
  created: async function () {
    // migration
    if (!this.contents.padding) this.contents.padding = {y: 0}

    if (this.contents.desktop.hasOwnProperty('full')) {
      if (this.contents.desktop.full) {
        this.contents.fullWidth = true
        delete this.contents.desktop.full
      } else {
        this.contents.fullWidth = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.native {
  @import './SlideImage2.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './SlideImage2.s.scss';
}
.tablet,
.desktop {
  @import './SlideImage2.m.scss';
}
.desktop {
  @import './SlideImage2.l.scss';
}

.smartphone-size {
  display: block;
  @media (min-width: 768px) {
    display: none;
  }
}
.tablet-size {
  display: none;
  @media (min-width: 768px) and (max-width: 1024px) {
    display: block;
  }
}
.desktop-size {
  display: none;
  @media (min-width: 1025px) {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contents/SlideImage2/SlideImage2.vue